"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var _Actions = _interopRequireDefault(require("./Actions.style"));

var Actions = function Actions(_ref) {
  var id = _ref.id,
      buttons = _ref.buttons,
      onIconClick = _ref.onIconClick,
      icon = _ref.icon;
  return _react.default.createElement(_Actions.default, null, buttons.map(function (_ref2, index) {
    var label = _ref2.label,
        _onClick = _ref2.onClick;
    return _react.default.createElement(_DarkButton.default.TextButton, {
      key: label,
      onClick: function onClick() {
        return _onClick(id);
      },
      style: {
        paddingRight: index === buttons.length - 1 ? '38px' : 0,
        fontSize: '12px',
        textTransform: 'uppercase'
      }
    }, label);
  }), icon && _react.default.createElement("button", {
    onClick: function onClick() {
      return onIconClick(id);
    },
    className: "close"
  }, _react.default.createElement(_Icon.default, {
    type: icon
  })));
};

Actions.propTypes = {
  id: _propTypes.default.string.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })),
  onIconClick: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string.isRequired
};
Actions.defaultProps = {
  buttons: []
};
var _default = Actions;
exports.default = _default;